import {
  GENERAL_PURCHASE_RETURN_REGISTER_REPORT_REQUEST,
  GENERAL_PURCHASE_RETURN_REGISTER_REPORT_SUCCESS,
  GENERAL_PURCHASE_RETURN_REGISTER_REPORT_FAILURE
} from "../types/general-purchase-return-report-types";

const initialState = {
  generalPurchaseReturnReports: {},
  loading: false,
  error: null,
};

const generalPurchaseReturnReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERAL_PURCHASE_RETURN_REGISTER_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GENERAL_PURCHASE_RETURN_REGISTER_REPORT_SUCCESS: {
      return {
        ...state,
        generalPurchaseReturnRegisterReport: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case GENERAL_PURCHASE_RETURN_REGISTER_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default generalPurchaseReturnReportReducer;
